export default __webpack_public_path__ + "static/media/SISF.6cf68e04.webp";